/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line
import { observer } from 'mobx-react'
import * as dayjs from 'dayjs'
import { Table, Icon } from 'antd'
// import { shopAction } from '../../action/shop'
import { shelfStore } from '../../store/list/ShelfModel'
import { GeneralStyles } from '../../styles/general'

// import BusinessStatus from '../../business/status'
// import StatusTag from '../../components/StatusTag'
import { buildListPage, LIST_PAGE_TYPES } from '../list_builder'

import ShelfAddMachineDrawer from '../../components/business/ShelfAddMachineDrawer'
import ShelfCreateDrawer from '../../components/business/ShelfCreateDrawer'

interface IShelfListProps { }

interface IShelfListState {
  pageList: any[]

  loading: boolean

  pagination: {
    current: number
    total: number
    size: number
  }
}

interface ShelfList {
  props: IShelfListProps
  state: IShelfListState
}

const pageColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '货架编号',
    dataIndex: 'shelf_code',
    key: 'shelf_code',
  },
  {
    title: '货架名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '货架描述',
    dataIndex: 'desc',
    key: 'desc',
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
    key: 'create_time',
    render: (text: any) => (
      <span>{dayjs(text).format('YYYY年MM月DD日 HH:mm:ss')}</span>
    ),
  },
  {
    title: '操作',
    key: 'action',
    render: (text: any, record: any) => (
      <span>
        <ShelfAddMachineDrawer record={record} text="添加机器" icon="plus"/>
      </span>
    ),
  },
]

@observer
class ShelfList extends Component {
  componentDidMount() {
    shelfStore.loadPageList()
  }

  handleTableChange = (pagination: any) => {
    if (pagination['current'] === shelfStore.listResponse.current) {
      return
    }

    shelfStore.changePage(pagination['current'])
  }

  render() {
    const listResponse = shelfStore.listResponse
    const pageList = listResponse.list.map((item: any) => {
      return {
        key: item['id'],
        ...item,
      }
    })
    const loadState = shelfStore.listError

    return (
      <div className="general-page" css={GeneralStyles['general-page']}>
        <div css={GeneralStyles['page-head']}>
          <div className="head-title">
            <span className="title-text"><Icon type="container" /> 货架列表</span>
          </div>
        </div>
        <div css={GeneralStyles['page-content']}>
          <div css={GeneralStyles['content-pane']} className="content-pane">
            <div css={GeneralStyles['simple-pane-inner']}>
              <div className="simple-line-item">
                <div className="simple-line-item">
                  <ShelfCreateDrawer text="创建货架" icon="plus"/>
                </div>
              </div>
            </div>
          </div>
          <div css={GeneralStyles['content-pane']} className="content-pane">
            <Table
              columns={pageColumns}
              rowKey={(record: any) => record.shelf_id}
              dataSource={pageList}
              pagination={{
                current: listResponse.current,
                total: listResponse.total,
                pageSize: listResponse.size,
              }}
              loading={loadState.state === 'loading'}
              onChange={this.handleTableChange}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default buildListPage(LIST_PAGE_TYPES.SHELF, ShelfList)
